import { CloudOff } from 'lucide-react';
import { isStandaloneApp } from '@/helpers/pwaHelpers';
import { useTheme } from '@/helpers/theme';

const ErrorFallback = ({ error }) => {
  useTheme();

  // eslint-disable-next-line no-console
  console.log(error);
  let message = 'Refresh the page to Try Again.';
  if (isStandaloneApp()) {
    message = 'Restart the app to Try Again.';
  }
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <CloudOff size={64} className="mb-12" />
      <h1 className="text-xl font-bold mb-2">Oops! Something went wrong</h1>
      <p className="text-muted-foreground mb-2">
        Don&apos;t worry, it&apos;s not you, it&apos;s us!
      </p>
      <p className="text-muted-foreground mb-2">{message}</p>
      <br />
      <p className="text-center px-6">
        If the problem persists, please contact support at{' '}
        <a href="mailto:info@profoundpros.com" className="underline">
          info@profoundpros.com
        </a>
        .
      </p>
    </div>
  );
};

export default ErrorFallback;
